import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ZoomInIcon = createIcon(
  'ZoomIn',
  <path d="M12,5 C12.6443322,5 13.1666667,5.52233446 13.1666667,6.16666667 L13.166,10.833 L17.8333333,10.8333333 C18.4776655,10.8333333 19,11.3556678 19,12 C19,12.6443322 18.4776655,13.1666667 17.8333333,13.1666667 L13.166,13.166 L13.1666667,17.8333333 C13.1666667,18.4776655 12.6443322,19 12,19 C11.3556678,19 10.8333333,18.4776655 10.8333333,17.8333333 L10.833,13.166 L6.16666667,13.1666667 C5.52233446,13.1666667 5,12.6443322 5,12 C5,11.3556678 5.52233446,10.8333333 6.16666667,10.8333333 L10.833,10.833 L10.8333333,6.16666667 C10.8333333,5.52233446 11.3556678,5 12,5 Z" />
);

export default ZoomInIcon;
